var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionDialog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 324,
    viewBox: "0 0 369 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.659 185.646L263.025 181.491L263.277 184.586L236.228 188.143C236.228 188.143 218.79 231.293 234.156 326.186H256.161L264.083 229.959H266.891L274.561 326.186H296.566C311.932 231.285 294.668 185.638 294.668 185.638L294.659 185.646Z",
    fill: "#8E716C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.011 229.96H276.969",
    stroke: "#282828",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.131 140.118C310.427 135.86 295.225 136.006 294.419 135.912C290.311 135.433 297.054 167.699 305.608 195.905C307.246 201.308 313.278 204.13 318.548 201.924C318.608 201.898 318.66 201.872 318.721 201.855C322.89 200.111 325.256 195.751 324.424 191.365C320.359 170.085 316.277 145.051 313.139 140.118H313.131Z",
    fill: "#FFB1A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.754 151.788L297.349 159.218L295.529 150.129L315.628 145.188L316.754 151.788Z",
    fill: "#F3978E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.421 169.965C320.421 169.965 311.226 182.149 311.668 181.584C312.11 181.02 318.879 161.895 318.879 161.895L320.421 169.957V169.965Z",
    fill: "#F3978E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.566 153.591L307.21 187.277C303.752 191.697 304.853 198.092 309.603 201.136C314.343 204.171 320.705 202.572 323.4 197.673L345.336 157.746L333.558 153.591H333.566Z",
    fill: "#FFB1A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.394 162.234C334.683 160.413 331.546 154.368 333.392 148.734C335.238 143.1 341.365 140.005 347.077 141.826C352.788 143.647 355.925 149.692 354.079 155.326C352.233 160.96 346.106 164.055 340.394 162.234Z",
    fill: "#FFB1A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 145.588C351.66 145.588 354.633 142.544 349.355 140.407C344.077 138.269 337.551 138.757 333.382 148.743L351.652 145.597L351.66 145.588Z",
    fill: "#FFB1A5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.134 124.289L368.167 129.009C368.782 129.274 369.008 129.992 368.67 130.616L354.153 157.368C353.815 157.992 353.043 158.283 352.428 158.018L341.395 153.299C340.78 153.034 340.554 152.315 340.892 151.691L355.409 124.939C355.747 124.315 356.519 124.024 357.134 124.289Z",
    fill: "#372F5F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M356.075 123.82L367.107 128.539C367.723 128.804 367.948 129.522 367.61 130.147L353.093 156.899C352.755 157.523 351.984 157.813 351.369 157.548L340.336 152.829C339.72 152.564 339.495 151.846 339.833 151.222L354.35 124.47C354.688 123.845 355.459 123.555 356.075 123.82Z",
    fill: "#261B43"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M354.834 126.537L364.524 130.692L352.693 152.494L342.995 148.347L354.834 126.537Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.524 130.692L342.995 148.347L354.834 126.537L364.524 130.692Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346.194 139.511C346.194 139.511 348.656 139.981 350.866 141.221C351.845 141.768 352.339 142.879 352.07 143.957C351.828 144.94 350.987 145.667 349.973 145.795L344.236 146.504C344.236 146.504 341.246 151.591 337.328 152.164L340.916 143.23L346.186 139.511H346.194Z",
    fill: "#FFB1A5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.916 97.6973C272.283 97.6973 313.606 103.34 320.419 149.808L298.977 153.048L294.652 188.136H234.834L222.96 123.312C222.96 123.312 236.212 104.58 260.817 97.6973H272.907H272.916Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M298.985 153.056L300.84 132.768",
    stroke: "#282828",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.84 98.3625V82.2207H257.66V98.5506C256.68 98.8413 255.042 99.4227 252.512 100.611L267.471 109.4L282.759 100.611C282.759 100.611 280.332 99.2175 276.84 98.3625Z",
    fill: "#FFB1A5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257.485 84.1957C257.485 84.1957 260.926 93.2156 270.122 92.4376C278.572 91.7194 277.228 79.2197 277.228 79.2197L257.485 84.1957Z",
    fill: "#282828"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M249.124 72.1909C246.116 74.884 239.4 64.6757 242.303 61.8115C245.206 58.9474 247.425 63.4445 247.425 63.4445L248.725 66.4882L249.704 70.6092L249.939 71.6864L249.132 72.1823L249.124 72.1909Z",
    fill: "#F3978E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.708 65.4352C243.708 65.4352 245.987 64.4263 248.007 67.6752",
    stroke: "#282828",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.675 71.8861C287.44 74.8187 295.014 65.2088 292.362 62.1138C289.71 59.0188 287.119 63.3108 287.119 63.3108L285.568 66.2348L284.242 70.2617L283.921 71.3218L284.684 71.8861H284.675Z",
    fill: "#F3978E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.648 65.6031C290.648 65.6031 288.464 64.4062 286.176 67.4841",
    stroke: "#282828",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.854 52.0933C243.854 65.5932 254.288 71.997 267.167 71.997C280.046 71.997 290.481 65.5932 290.481 52.0933C290.481 38.5933 280.046 29.4023 267.167 29.4023C254.288 29.4023 243.854 38.5847 243.854 52.0933Z",
    fill: "#282828"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.017 53.0323C247.017 61.3255 248.204 68.4731 249.391 73.5516C250.553 78.519 253.82 81.9987 258.431 84.7945L259.272 85.3074C264.151 88.2656 270.461 88.334 275.418 85.487C280.419 82.6143 283.92 78.8182 284.995 73.4832C286.954 63.7793 287.17 53.0409 287.17 53.0409C287.17 53.0409 289.034 32.1112 267.384 32.5216C245.734 32.932 247.025 53.0409 247.025 53.0409L247.017 53.0323Z",
    fill: "#FFB1A5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M265.78 64.9688V67.8671C265.78 68.0381 265.815 68.2005 265.876 68.3544C266.118 68.9444 266.812 69.2265 267.436 69.0641L268.779 68.7135",
    stroke: "#282828",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 53.7427L251.575 56.2307C251.575 56.2307 252.061 53.529 256.463 52.5457C260.866 51.5625 262.331 53.7427 262.331 53.7427H262.339Z",
    fill: "#282828"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M271.891 53.7427L282.282 56.2307C282.282 56.2307 281.814 53.529 277.559 52.5457C273.312 51.5625 271.891 53.7427 271.891 53.7427Z",
    fill: "#282828"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.25 63.3277C259.25 63.3277 260.061 62.5277 260.061 61.5408C260.061 60.5539 259.25 59.7539 258.25 59.7539C257.249 59.7539 256.438 60.5539 256.438 61.5408C256.438 62.5277 257.249 63.3277 258.25 63.3277Z",
    fill: "#282828"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.274 61.5408C277.274 62.524 276.459 63.3277 275.463 63.3277C274.466 63.3277 273.651 62.5326 273.651 61.5408C273.651 60.549 274.466 59.7539 275.463 59.7539C276.459 59.7539 277.274 60.549 277.274 61.5408Z",
    fill: "#282828"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M260.069 72.4404H274.066C274.066 72.4404 267.861 79.8872 260.069 72.4404Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M262.942 67.611C265.954 64.6394 265.954 59.8215 262.942 56.8499C259.93 53.8783 255.046 53.8783 252.033 56.8499C249.021 59.8215 249.021 64.6394 252.033 67.611C255.046 70.5826 259.93 70.5826 262.942 67.611Z",
    stroke: "#C98BD2",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M281.896 67.61C284.908 64.6384 284.908 59.8205 281.896 56.8489C278.884 53.8774 274 53.8773 270.987 56.8489C267.975 59.8205 267.975 64.6384 270.987 67.61C274 70.5816 278.884 70.5816 281.896 67.61Z",
    stroke: "#C98BD2",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M265.206 62.2329C265.206 62.2329 267.035 60.5487 268.733 62.2329",
    stroke: "#C98BD2",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M249.772 62.2345L247.337 62.1738",
    stroke: "#C98BD2",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M284.162 62.2345L286.606 62.1738",
    stroke: "#C98BD2",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M286.894 59.9664C286.894 59.9664 278.235 48.4243 280.229 36.7197C280.229 36.7197 286.651 39.9088 288.332 48.1421C290.005 56.3755 286.894 59.9578 286.894 59.9578V59.9664Z",
    fill: "#282828"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M247.008 60.7517C247.008 60.7517 257.062 47.6364 255.069 35.9404C255.069 35.9404 248.092 39.916 246.419 48.1494C244.746 56.3828 247.008 60.7517 247.008 60.7517Z",
    fill: "#282828"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M286.165 41.3283C286.165 41.3283 275.046 53.3321 244.634 51.2802C244.634 51.2802 249.288 33.6593 264.03 31.7869C264.03 31.7869 281.052 29.7862 286.165 41.3283Z",
    fill: "#282828"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.73 29.587C301.009 21.7743 295.625 14.4185 287.705 13.1573C279.785 11.8961 272.329 17.2071 271.05 25.0198C269.772 32.8326 275.156 40.1884 283.075 41.4496C290.995 42.7108 298.452 37.3997 299.73 29.587Z",
    fill: "#282828"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.113 185.614L81.0635 182.057L81.3062 178.962L49.6722 183.117C49.6722 183.117 32.4079 228.764 47.7742 323.657H69.7793L77.4494 227.43H80.2575L88.179 323.657H110.184C125.55 228.755 108.113 185.614 108.113 185.614Z",
    fill: "#282828"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.957 55.7875C102.299 51.5383 99.3613 46.5795 96.8739 39.6286C94.1959 32.1647 85.4423 35.1999 85.4423 35.1999C85.4423 35.1999 78.1449 25.9405 67.164 29.1638C56.1831 32.387 52.3697 40.0988 52.1444 49.2641C51.919 58.4294 44.6129 59.8572 38.9881 70.4588C29.0559 89.1741 45.7742 104.94 76.2208 100.562L76.2642 100.272C79.2629 101.169 82.9376 101.563 87.4184 101.298C123.992 99.1516 120.456 72.6219 105.957 55.7875Z",
    fill: "#282828"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9866 69.6713C96.9939 72.3645 103.711 62.1562 100.807 59.292C97.904 56.4279 95.6853 60.925 95.6853 60.925L94.3852 63.9687L93.4059 68.0897L93.1719 69.1669L93.9779 69.6628L93.9866 69.6713Z",
    fill: "#F3978E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4062 62.9088C99.4062 62.9088 97.1268 61.9 95.1074 65.1488",
    stroke: "#282828",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4353 69.3539C55.6705 72.2864 48.0957 62.6766 50.7478 59.5816C53.3998 56.4866 55.9912 60.7785 55.9912 60.7785L57.5426 63.7025L58.8686 67.7294L59.1893 68.7896L58.4266 69.3539H58.4353Z",
    fill: "#F3978E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4551 63.0709C52.4551 63.0709 54.6391 61.8739 56.9272 64.9518",
    stroke: "#282828",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2575 49.563C99.2575 63.063 88.8226 69.4667 75.9437 69.4667C63.0648 69.4667 52.6299 63.063 52.6299 49.563C52.6299 36.063 63.0648 26.8721 75.9437 26.8721C88.8226 26.8721 99.2575 36.0545 99.2575 49.563Z",
    fill: "#282828"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4424 79.6924H66.2627V104.187H85.4424V79.6924Z",
    fill: "#FFB1A5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4717 78.1709C63.4717 78.1709 68.8105 88.6785 75.3799 90.32C77.1306 90.7561 79.0113 90.6107 80.7014 90.0208C83.1714 89.1573 86.3088 85.5236 86.8375 81.4967L87.0888 79.1969C87.0888 79.1969 75.4059 85.4723 63.4803 78.1709H63.4717Z",
    fill: "#282828"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0853 50.502C96.0853 58.7952 94.8979 65.9428 93.7105 71.0213C92.5492 75.9887 89.2818 79.4684 84.671 82.2642L83.8303 82.7772C78.9509 85.7354 72.6415 85.8038 67.684 82.9567C62.6833 80.084 59.1819 76.2879 58.1072 70.9529C56.1485 61.249 55.9318 50.5106 55.9318 50.5106C55.9318 50.5106 54.0684 29.5809 75.7182 29.9913C97.3679 30.4017 96.0766 50.5106 96.0766 50.5106L96.0853 50.502Z",
    fill: "#FFB1A5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4951 63.5752V65.2937C74.4951 65.4647 74.5298 65.6271 74.5905 65.781C74.8331 66.3709 75.5265 66.6531 76.1505 66.4906L77.4938 66.1401",
    stroke: "#282828",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0107 52.2297L90.529 54.9228C90.529 54.9228 90.009 51.9989 85.2942 50.9387C80.5794 49.8785 79.0107 52.2297 79.0107 52.2297Z",
    fill: "#282828"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9624 52.2297L61.2969 54.9228C61.2969 54.9228 61.8255 51.9989 66.601 50.9387C71.3764 49.8785 72.9624 52.2297 72.9624 52.2297Z",
    fill: "#282828"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7839 59.2822C68.7839 60.2655 67.9692 61.0606 66.9725 61.0606C65.9758 61.0606 65.1611 60.2655 65.1611 59.2822C65.1611 58.299 65.9758 57.5039 66.9725 57.5039C67.9692 57.5039 68.7839 58.299 68.7839 59.2822Z",
    fill: "#282828"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M85.988 59.2822C85.988 60.2655 85.1733 61.0606 84.1766 61.0606C83.1799 61.0606 82.3652 60.2655 82.3652 59.2822C82.3652 58.299 83.1799 57.5039 84.1766 57.5039C85.1733 57.5039 85.988 58.299 85.988 59.2822Z",
    fill: "#282828"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5791 69.4658H83.5087C83.5087 69.4658 82.3821 73.7834 75.1626 73.7834C69.6591 73.7834 67.5791 69.4658 67.5791 69.4658Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2198 57.4371C56.2198 57.4371 64.878 45.895 62.8846 34.1904C62.8846 34.1904 56.4625 37.3795 54.7811 45.6128C53.1084 53.8462 56.2198 57.4285 56.2198 57.4285V57.4371Z",
    fill: "#282828"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.101 57.053C96.101 57.053 86.0475 45.1091 88.0409 33.4131C88.0409 33.4131 95.0177 37.3887 96.6904 45.6221C98.3631 53.8554 96.101 57.053 96.101 57.053Z",
    fill: "#282828"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9355 38.8078C56.9355 38.8078 66.8678 51.9829 97.2884 49.9224C97.2884 49.9224 93.813 31.1388 79.0707 29.2664C79.0707 29.2664 62.049 27.2657 56.9355 38.8078Z",
    fill: "#282828"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.208 243.558C28.766 244.242 54.5238 133.002 46.8797 134.686C46.1777 134.84 32.7874 136.062 30.8027 140.055C25.0306 151.631 20.8965 242.711 20.8965 242.711L29.2167 243.558H29.208Z",
    fill: "#FFB1A5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8885 242.712C20.8885 242.712 16.7371 261.709 32.4327 263.787C33.4641 263.924 34.4694 263.325 34.8075 262.35L34.8508 262.222C35.2235 261.145 34.6775 259.999 33.6288 259.538C31.0721 258.409 27.1026 255.553 29.07 249.081C29.07 249.081 31.3407 248.808 32.5887 252.98C32.9094 254.057 34.1314 254.596 35.1455 254.091C35.8388 253.749 36.2288 253.014 36.1335 252.253C35.7608 249.329 34.2701 242.293 28.55 240.403L20.8972 242.712H20.8885Z",
    fill: "#FFB1A5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1758 166.781C26.1758 166.781 41.0134 187.395 41.0914 187.001C41.1694 186.6 46.2828 158.052 46.2828 158.052L28.2732 150.357L26.1758 166.781Z",
    fill: "#F3978E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4032 100.161C68.0358 100.161 30.7251 100.819 23.9043 147.287L45.3461 150.527L49.6708 185.615H109.489L121.363 120.791C121.363 120.791 112.921 106.744 88.3163 99.8701L67.4032 100.161Z",
    fill: "#61C9C1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.167 105.777C49.167 105.777 54.4364 112.685 76.0429 112.685C97.6493 112.685 102.919 105.418 102.919 105.418C102.919 105.418 90.2998 98.4671 75.6615 96.21C75.6615 96.21 62.5919 98.5098 49.167 105.777Z",
    fill: "#FFB1A5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.578 253L122.63 345.687H169.11L172.681 253H122.578Z",
    fill: "#005683"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M223.496 253L223.444 345.687H176.963L173.393 253H223.496Z",
    fill: "#005683"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.111 253H150.054V285.198H198.111V253Z",
    fill: "#005683"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M156.77 285.198H189.912",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M252.86 172.122C255.746 203.525 252.704 226.413 253.545 284.2L225.802 285.346L221.668 177.175L252.86 172.122Z",
    fill: "#FFB1A5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M225.093 196.625C225.093 196.625 242.27 195.077 254.014 187.434L253.702 180.705L225.075 184.552V196.625H225.093Z",
    fill: "#F3978E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M197.53 99.8086C197.53 99.8086 252.097 113.343 261.986 181.672C261.986 181.672 235.283 193.094 208.52 188.178L214.543 165.325L197.539 99.8086H197.53Z",
    fill: "#C98BD2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5419 128.222L75.1721 175.553L62.7438 210.094C62.7438 210.094 31.8639 167.738 17.9883 135.002L34.5506 128.222H34.5419Z",
    fill: "#FFB1A5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8792 129.934C35.8792 129.934 21.6136 137.886 17.9822 135.013C11.6381 129.986 6.40332 111.587 6.40332 111.587C6.40332 111.587 33.0799 101.669 32.8285 102.054C32.5772 102.439 35.8792 129.934 35.8792 129.934Z",
    fill: "#FFB1A5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8802 129.932C35.6288 128.513 41.1669 113.234 43.0736 107.497C43.533 106.112 42.5623 104.599 41.0456 104.308C40.0576 104.12 38.4889 104.24 37.7435 105.642L31.0527 116.928L35.8802 129.932Z",
    fill: "#FFB1A5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3853 113.406L30.7919 90.8605C30.5232 89.3643 28.9892 88.3297 27.4638 88.6119C26.1465 88.8598 25.2711 90.014 25.4271 91.3221L27.4292 108.114L35.3767 113.415L35.3853 113.406Z",
    fill: "#FFB1A5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2503 105.088L20.0101 88.9886C19.4901 87.5779 17.8868 86.7999 16.4654 87.2701C15.2347 87.6805 14.5414 88.9031 14.836 90.1599L19.4641 108.764L26.2503 105.096V105.088Z",
    fill: "#FFB1A5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5509 109.841L11.6554 94.0241C10.9274 92.5535 9.12472 91.8781 7.65136 92.5108C6.26466 93.1092 5.64932 94.6567 6.23866 96.076L12.5308 111.012L19.5509 109.85V109.841Z",
    fill: "#FFB1A5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40313 111.585L0.206345 101.889C-0.304999 100.752 0.16301 99.4697 1.2897 98.9653C2.36439 98.478 3.69041 98.8627 4.38376 99.8545L12.5306 111.003L6.40313 111.585Z",
    fill: "#FFB1A5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1365 111.713C34.1365 111.713 24.837 110.747 23.875 122.982",
    stroke: "#282828",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4951 193.942C54.4951 193.942 62.1393 220.028 77.3669 216.565C92.5945 213.094 116.324 181.015 116.324 181.015L111.012 126.237L68.2754 178.125L54.4951 193.951V193.942Z",
    fill: "#FFB1A5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5361 162.001C81.5361 162.001 95.9664 183.469 108.273 191.045L116.333 181.016L85.2542 157.299L81.5361 162.01V162.001Z",
    fill: "#F3978E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.663 98.6309C144.663 98.6309 102.3 108.053 79.7227 156.623C79.7227 156.623 93.3643 176.895 115.231 185.906L129.869 168.217L144.663 98.6309Z",
    fill: "#C98BD2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M144.662 98.4756C128.117 106.846 117.708 117.952 117.708 117.952L120.975 259.928H225.263L224.925 118.687C224.925 118.687 211.778 105.999 197.53 99.8093C185.431 94.5513 156.423 92.525 144.662 98.4756Z",
    fill: "#C98BD2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M179.502 139.036H208.51V153.348C208.51 161.248 202.01 167.661 194.001 167.661C185.993 167.661 179.493 161.248 179.493 153.348V139.036H179.502Z",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M225.09 188.71L226.442 142.268",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M119.311 180.971L117.058 140.711",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M145.885 46.6219L141.535 25.4101C141.292 23.683 140.607 21.0155 141.439 18.5105C142.817 14.3639 147.879 6.40408 156.528 10.0463L158.4 18.4421C158.4 18.4421 149.422 20.229 145.816 31.8223L145.885 46.6219Z",
    fill: "#282828"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M155.895 14.4229C155.739 17.2101 153.243 29.4105 144.472 33.8478C144.472 33.8478 136.794 17.5948 155.895 14.4229Z",
    fill: "#282828"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M186.654 94.5675V58.5391H152.992V94.5675L142.973 99.0732C142.973 99.0732 145.321 114.001 170.178 114.334C195.034 114.668 197.53 99.8085 197.53 99.8085L186.654 94.5675Z",
    fill: "#FFB1A5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M156.528 10.0369C156.528 10.0369 162.708 -6.04511 181.757 2.50459C193.293 7.67716 196.517 14.611 197.895 19.527C198.354 21.16 198.536 23.7335 198.406 25.2639L193.796 46.6125L175.803 17.0733L158.392 18.4327L156.52 10.0369H156.528Z",
    fill: "#282828"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M193.803 46.6194C193.803 46.6194 196.074 43.0542 200.754 44.8069C205.434 46.5596 203.319 57.7768 196.299 59.2046C196.299 59.2046 193.786 59.7432 191.81 58.0418C191.81 58.0418 193.534 49.7571 193.812 46.6109L193.803 46.6194Z",
    fill: "#F3978E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M199.827 48.7663C199.827 48.7663 195.91 47.4753 193.119 53.1694",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M145.884 46.6194C145.884 46.6194 143.614 43.0542 138.934 44.8069C134.253 46.5596 136.368 57.7768 143.388 59.2046C143.388 59.2046 145.902 59.7432 147.878 58.0418C147.878 58.0418 146.153 49.7571 145.876 46.6109L145.884 46.6194Z",
    fill: "#F3978E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.859 48.7663C139.859 48.7663 143.777 47.4753 146.567 53.1694",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M194.27 35.9766C194.27 42.7394 193.602 56.8806 189.382 65.2764C185.43 73.1592 178.886 77.3999 170.306 77.6564C161.726 77.9128 155.338 74.6469 150.216 64.4129C145.094 54.1789 145.337 36.0963 145.337 36.0963C145.337 36.0963 145.337 11.9434 169.535 11.9434C195.024 11.9434 194.261 35.968 194.261 35.968L194.27 35.9766Z",
    fill: "#FFB1A5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 69.457C153.241 69.457 156.058 83.5726 168.512 85.1885C182.838 87.0523 186.652 69.8161 186.652 69.8161C186.652 69.8161 180.325 77.6391 170.306 77.6562C159.143 77.6733 153.241 69.457 153.241 69.457Z",
    fill: "#282828"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M168.081 46.0049V51.5964C168.081 51.8358 168.124 52.0666 168.211 52.2804C168.549 53.1097 169.511 53.503 170.386 53.2721L172.267 52.7762",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M160.941 43.3386C160.941 44.5356 159.953 45.5102 158.739 45.5102C157.526 45.5102 156.538 44.5356 156.538 43.3386C156.538 42.1417 157.526 41.167 158.739 41.167C159.953 41.167 160.941 42.1417 160.941 43.3386Z",
    fill: "#282828"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M181.591 43.3386C181.591 44.5356 180.603 45.5102 179.39 45.5102C178.177 45.5102 177.188 44.5356 177.188 43.3386C177.188 42.1417 178.177 41.167 179.39 41.167C180.603 41.167 181.591 42.1417 181.591 43.3386Z",
    fill: "#282828"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M173.749 32.5228L188.561 36.2932C188.561 36.2932 187.885 32.1979 181.827 30.7017C175.768 29.214 173.749 32.5142 173.749 32.5142V32.5228Z",
    fill: "#282828"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M164.545 32.5228L149.733 36.2932C149.733 36.2932 150.409 32.1979 156.468 30.7017C162.526 29.214 164.545 32.5142 164.545 32.5142V32.5228Z",
    fill: "#282828"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M161.6 57.2217C161.6 57.2217 163.784 58.8718 169.53 58.8718C174.756 58.8718 178.015 57.2217 178.015 57.2217",
    stroke: "#282828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M158.14 53.2027C163.31 53.2027 167.501 49.0686 167.501 43.969C167.501 38.8694 163.31 34.7354 158.14 34.7354C152.971 34.7354 148.78 38.8694 148.78 43.969C148.78 49.0686 152.971 53.2027 158.14 53.2027Z",
    stroke: "white",
    strokeWidth: 1.95,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M181.135 53.2027C186.304 53.2027 190.495 49.0686 190.495 43.969C190.495 38.8694 186.304 34.7354 181.135 34.7354C175.965 34.7354 171.774 38.8694 171.774 43.969C171.774 49.0686 175.965 53.2027 181.135 53.2027Z",
    stroke: "white",
    strokeWidth: 1.95,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M167.501 43.9687C167.501 43.9687 169.72 41.9253 171.774 43.9687",
    stroke: "white",
    strokeWidth: 1.95,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M148.781 43.9696L145.644 43.8916",
    stroke: "white",
    strokeWidth: 1.95,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M190.494 43.9708L194.004 43.9102",
    stroke: "white",
    strokeWidth: 1.95,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M153.243 14.9703C153.243 14.9703 157.741 27.5725 178.022 27.1792C191.802 26.9142 195.095 36.7549 195.095 36.7549C195.095 36.7549 192.694 14.7565 192.062 14.9703C191.429 15.1755 171.088 9.61816 171.088 9.61816L153.234 14.9703H153.243Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionDialog);
export default __webpack_public_path__ + "static/media/subscription-dialog.93404eb1396a940f613199fb28940487.svg";
export { ForwardRef as ReactComponent };